<template>
  <div>
    <div class="table_tr">
      <div style="width:50%">
        {{ $t(`lang.str_tzje`) }}
      </div>
      <div style="width:50%">
        {{ (bet / 100).toFixed(2) }}
      </div>
    </div>
    <div class="table_tr">
      <div style="width:50%">
        {{ $t(`lang.str_tzfx`) }}
      </div>
      <div style="width:50%">
        {{ tzfx == 2 ? $t("lang.str_tzfx_zd") : (tzfx == 3 ? $t("lang.str_tzfx_gd") : $t("lang.str_tzfx_dd")) }}
      </div>
    </div>
    <div class="table_tr">
      <div style="width:50%">
        {{ $t(`lang.str_tzds`) }}
      </div>
      <div style="width:50%">
        {{ tzds }}
      </div>
    </div>
    <div class="table_tr">
      <div style="width:50%">
        {{ $t(`lang.str_jgbs`) }}
      </div>
      <div style="width:50%">
        {{ jgbs }}
      </div>
    </div>
    <div class="table_tr" :class="{yellow_color:checkWin()}">
      <div style="width:50%">
        {{ $t(`lang.str_game_win_result`) }}
      </div>
      <div style="width:50%">
        <div>{{ checkWin()? $t(`lang.str_t`):$t(`lang.str_f`) }}</div>
      </div>
    </div>
    <div class="table_tr">
      <div style="width:50%">
        {{ $t(`lang.str_jg`) }}
      </div>
      <div style="width:50%">
        {{ (jg / 100).toFixed(2) }}
      </div>
    </div>
    <DescribeLayout
      :winValueTip="winValueTip"
      :winValueTotal="winValueTotal"
      :isTotalWin="isTotalWin"
      :describe_title="describe_title"
      :describe_content="describe_content"
      :describe_message="describe_message">
    </DescribeLayout>
  </div>
</template>
<script>
import DescribeLayout from "../common/describe_layout.vue";

export default {
  name: "Game3009",
  components: {DescribeLayout},
  props:{
    winValueTip:null,
    winValueTotal:null,
    describe_title:null,
    isTotalWin:false,
    describe_content:null,
    describe_message:null,
    bet:0,
    tzfx:0,
    jgbs:0,
    tzds:0,
    jg:0,
    lang: '',
    Phone:false,
  },
  data()
  {
    return {

    }
  },
  methods: {
    checkWin()
    {
      return this.jgbs>0;
    }
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/esports/game_3009.vue